import { computed, type Ref } from 'vue'

import type { ContentItem } from '../content-item-details.types'

export type UseMediaCarouselOptions = {
  contentItems: Ref<ContentItem[]>
  activeContentItem: Ref<ContentItem | undefined>
  onSelect: (item: ContentItem) => void
}

export const useMediaCarousel = ({
  contentItems,
  activeContentItem,
  onSelect,
}: UseMediaCarouselOptions) => {
  const activeAssetIndex = computed(() =>
    contentItems.value.findIndex((item) => item.id === activeContentItem.value?.id),
  )
  const canPrevAsset = computed(() => activeAssetIndex.value > 0)
  const canNextAsset = computed(
    () => activeAssetIndex.value >= 0 && activeAssetIndex.value < contentItems.value.length - 1,
  )

  const goToAsset = (offset: number) => {
    const target = contentItems.value[activeAssetIndex.value + offset]
    if (target) {
      onSelect(target)
    }
  }

  return { activeAssetIndex, canPrevAsset, canNextAsset, goToAsset }
}
